import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ actions }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 gap-3">
        {actions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant || 'outline'}
            iconName={action?.icon}
            iconPosition="left"
            onClick={() => navigate(action?.path)}
            fullWidth
            className="justify-start"
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionCard;